const resources = {
    new: 'Nouveauté',
    value: 'valeur',
    colors: 'Couleurs',
    quickLook: 'Aperçu rapide'
};

module.exports = function getResource(label) {
    return resources[label];
};
